import { html } from 'lit';
import { choose } from 'lit/directives/choose.js';
import { formatDate } from '../../../format-date.js';
import { OrderStatus } from '../../../interfaces/index.js';

import {
  PendingIcon,
  ReceivedIcon,
  ProcessingIcon,
  CompletedIcon,
  CancelledIcon,
  PaidIcon,
} from './status-icons.js';

const stateMap: Record<OrderStatus, string> = {
  pending: 'Auftrag angelegt',
  received: 'Eingegangen',
  processing: 'In Bearbeitung',
  completed: 'Abgeschlossen',
  paid: 'Bereit zum Download',
  cancelled: 'Abgebrochen',
};

export const renderOrderMeta = (
  status: OrderStatus,
  code: string,
  date: string
) => {
  return html`
    <div id="order-status">
      <div id="icon">
        ${choose(status, [
          ['pending', () => PendingIcon],
          ['received', () => ReceivedIcon],
          ['processing', () => ProcessingIcon],
          ['completed', () => CompletedIcon],
          ['paid', () => PaidIcon],
          ['cancelled', () => CancelledIcon],
        ])}
      </div>
      <div id="meta">
        <h2>${stateMap[status]}</h2>
        <time datetime="${date}">${formatDate(date)}</time>
      </div>
      <span aria-label="Auftragsnummer: ${code}">${code}</span>
    </div>
  `;
};
